<div class="d-flex row wp-share align-items-center">
  <div class="col-md-6 text-center">
    <img [src]="parseURL(block.data.image_url)" [alt]="block.data.alt_text ?? 'Share Image'">
  </div>
  <div class="col-md-6">
    <h2 class="wp-share__title" *ngIf="block.data.ctaTitle" [innerText]="block.data.ctaTitle"></h2>
    <div class="wp-share__text" *ngIf="block.data.ctaText" [innerHTML]="block.data.ctaText"></div>
  </div>
</div>
